import axios from "axios";
import label from "@/lang/StaticLabels.js";
const hamyarUrl = "sale/api/v1/";

// زمان‌سنج‌های روشن در localStorage می‌مانند تا ویجت بعد از رفرش هم برگردد
// (API فهرست زمان‌سنج‌های در حال اجرا ندارد)
const TIMER_STORAGE_KEY = "mita-task-timers";

const readRunningTimers = () => {
  try {
    const list = JSON.parse(localStorage.getItem(TIMER_STORAGE_KEY) || "[]");
    return Array.isArray(list) ? list.filter((item) => item && item.id) : [];
  } catch (e) {
    return [];
  }
};

const saveRunningTimers = (timers) => {
  try {
    const list = Object.values(timers)
      .filter((timer) => timer.isRunning)
      .map((timer) => ({ id: timer.taskId, title: timer.title }));
    localStorage.setItem(TIMER_STORAGE_KEY, JSON.stringify(list));
  } catch (e) {
    // ذخیره نشد؛ فقط تا رفرش بعدی در حافظه می‌ماند
  }
};

const timerRecord = (result, id, title) => ({
  ...result,
  taskId: id,
  title: title || "",
  at: Date.now(),
});

// CheckListBaseDto در ثبت/ویرایش موجودیت‌ها isDone ندارد و سرور با هر ذخیره تیک‌ها را false می‌کند؛
// وضعیت تیک از payload جدا می‌شود و بعد از ذخیره با CheckList/SetDone دوباره اعمال می‌شود
const CHECK_DONE_FIELDS = ["isDone", "doneDate", "doneTime", "doneDescription"];

const splitCheckDone = (payload) => {
  const list =
    payload && Array.isArray(payload.checkList) ? payload.checkList : null;
  if (!list) return { body: payload, wanted: null };
  const wanted = list.map((item) => ({
    id: item.id ?? null,
    title: item.title,
    isDone: item.isDone === true,
  }));
  const checkList = list.map((item) => {
    const row = { ...item };
    CHECK_DONE_FIELDS.forEach((key) => delete row[key]);
    return row;
  });
  return { body: { ...payload, checkList }, wanted };
};

const restoreCheckDone = (path, saved, wanted) => {
  // پاسخ ثبت جدید یا خود id است یا رکوردی با id
  const id = typeof saved === "string" ? saved : saved?.id;
  // بدون آیتم تیک‌خورده چیزی برای بازگرداندن نیست (سرور همه را false نگه می‌دارد)
  if (!id || typeof id !== "string" || !(wanted || []).some((w) => w.isDone)) {
    return Promise.resolve();
  }
  return axios
    .get(hamyarUrl + path + id)
    .then((res) => {
      const rows = res.data?.data?.checkList ?? [];
      const used = new Set();
      const ids = { done: [], undone: [] };
      wanted.forEach((want) => {
        // اول با id، اگر سرور ردیف‌ها را از نو ساخته بود با عنوان
        const free = (row) => !used.has(row.id);
        const row =
          (want.id && rows.find((r) => free(r) && r.id === want.id)) ||
          rows.find((r) => free(r) && r.title === want.title);
        if (!row) return;
        used.add(row.id);
        if ((row.isDone === true) !== want.isDone) {
          ids[want.isDone ? "done" : "undone"].push(row.id);
        }
      });
      return Promise.all(
        Object.keys(ids)
          .filter((key) => ids[key].length)
          .map((key) =>
            axios.put(hamyarUrl + "operation/hamyar/CheckList/SetDone", {
              ids: ids[key],
              isDone: key === "done",
            }),
          ),
      );
    })
    .catch(() => null); // ذخیره‌ی اصلی موفق بوده؛ خطای تیک مانع پیام موفقیت نشود
};

export default {
  // Goal Actions ------------------------------------------------------------------
  getGoals({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(hamyarUrl + "operation/hamyar/Goal?" + data)
      .then((res) => {
        commit("setGoals", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getGoal({ dispatch, commit }, data) {
    axios
      .get(hamyarUrl + "operation/hamyar/Goal/" + data)
      .then((res) => {
        commit("setGoal", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // جزئیات هدف (کاربران هدف و زمان‌بندی هدف) برای مدال‌های صفحه‌ی لیست اهداف.
  // بدون setLoading سراسری؛ خودِ مدال وضعیت بارگذاری را نشان می‌دهد و
  // promise برگردانده می‌شود تا فراخواننده پایان درخواست را بفهمد.
  getGoalDetail({ dispatch, commit }, data) {
    return axios
      .get(hamyarUrl + "operation/hamyar/Goal/" + data)
      .then((res) => {
        commit("setGoalDetail", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addGoal({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(hamyarUrl + "operation/hamyar/Goal", data)
      .then((res) => {
        commit("setGoalId", res.data.data);
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editGoal({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(hamyarUrl + "operation/hamyar/Goal/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteGoal({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(hamyarUrl + "operation/hamyar/Goal", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getGoalCode({ dispatch, commit }) {
    axios
      .get(hamyarUrl + "operation/hamyar/Goal/MaxCode")
      .then((res) => {
        commit("setGoalCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // GoalUser Actions ------------------------------------------------------------------
  getGoalUsers({ dispatch, commit }, data) {
    axios
      .get(hamyarUrl + "operation/hamyar/GoalUser?" + data)
      .then((res) => {
        commit("setGoalUsers", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addGoalUser({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(hamyarUrl + "operation/hamyar/GoalUser", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editGoalUser({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(hamyarUrl + "operation/hamyar/GoalUser/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteGoalUser({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(hamyarUrl + "operation/hamyar/GoalUser", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // GoalSchedule Actions ------------------------------------------------------------------
  getGoalSchedules({ dispatch, commit }, data) {
    axios
      .get(hamyarUrl + "operation/hamyar/GoalSchedule?" + data)
      .then((res) => {
        commit("setGoalSchedules", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addGoalSchedule({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(hamyarUrl + "operation/hamyar/GoalSchedule", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editGoalSchedule({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(hamyarUrl + "operation/hamyar/GoalSchedule/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteGoalSchedule({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(hamyarUrl + "operation/hamyar/GoalSchedule", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // TaskCategory Actions ------------------------------------------------------------------
  getTaskCategorys({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(hamyarUrl + "basic/hamyar/TaskCategory?" + data)
      .then((res) => {
        commit("setTaskCategorys", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getTaskCategory({ dispatch, commit }, data) {
    axios
      .get(hamyarUrl + "basic/hamyar/TaskCategory/" + data)
      .then((res) => {
        commit("setTaskCategory", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addTaskCategory({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(hamyarUrl + "basic/hamyar/TaskCategory", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editTaskCategory({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(hamyarUrl + "basic/hamyar/TaskCategory/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteTaskCategory({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(hamyarUrl + "basic/hamyar/TaskCategory", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getTaskCategoryCode({ dispatch, commit }) {
    axios
      .get(hamyarUrl + "basic/hamyar/TaskCategory/MaxCode")
      .then((res) => {
        commit("setTaskCategoryCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // NoteCategory Actions ------------------------------------------------------------------
  getNoteCategorys({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(hamyarUrl + "basic/hamyar/NoteCategory?" + data)
      .then((res) => {
        commit("setNoteCategorys", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getNoteCategory({ dispatch, commit }, data) {
    axios
      .get(hamyarUrl + "basic/hamyar/NoteCategory/" + data)
      .then((res) => {
        commit("setNoteCategory", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addNoteCategory({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(hamyarUrl + "basic/hamyar/NoteCategory", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editNoteCategory({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(hamyarUrl + "basic/hamyar/NoteCategory/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteNoteCategory({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(hamyarUrl + "basic/hamyar/NoteCategory", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getNoteCategoryCode({ dispatch, commit }) {
    axios
      .get(hamyarUrl + "basic/hamyar/NoteCategory/MaxCode")
      .then((res) => {
        commit("setNoteCategoryCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // ProjectType Actions ------------------------------------------------------------------
  getProjectTypes({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(hamyarUrl + "basic/hamyar/ProjectType?" + data)
      .then((res) => {
        commit("setProjectTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getProjectType({ dispatch, commit }, data) {
    axios
      .get(hamyarUrl + "basic/hamyar/ProjectType/" + data)
      .then((res) => {
        commit("setProjectType", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addProjectType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(hamyarUrl + "basic/hamyar/ProjectType", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editProjectType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(hamyarUrl + "basic/hamyar/ProjectType/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteProjectType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(hamyarUrl + "basic/hamyar/ProjectType", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getProjectTypeCode({ dispatch, commit }) {
    axios
      .get(hamyarUrl + "basic/hamyar/ProjectType/MaxCode")
      .then((res) => {
        commit("setProjectTypeCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // WorkDescription Actions ------------------------------------------------------------------
  getWorkDescriptions({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(hamyarUrl + "basic/hamyar/WorkDescription?" + data)
      .then((res) => {
        commit("setWorkDescriptions", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getWorkDescription({ dispatch, commit }, data) {
    axios
      .get(hamyarUrl + "basic/hamyar/WorkDescription/" + data)
      .then((res) => {
        commit("setWorkDescription", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addWorkDescription({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(hamyarUrl + "basic/hamyar/WorkDescription", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editWorkDescription({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(hamyarUrl + "basic/hamyar/WorkDescription/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteWorkDescription({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(hamyarUrl + "basic/hamyar/WorkDescription", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getWorkDescriptionCode({ dispatch, commit }) {
    axios
      .get(hamyarUrl + "basic/hamyar/WorkDescription/MaxCode")
      .then((res) => {
        commit("setWorkDescriptionCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // NoteSubject Actions ------------------------------------------------------------------
  getNoteSubjects({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(hamyarUrl + "basic/hamyar/NoteSubject?" + data)
      .then((res) => {
        commit("setNoteSubjects", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getNoteSubject({ dispatch, commit }, data) {
    axios
      .get(hamyarUrl + "basic/hamyar/NoteSubject/" + data)
      .then((res) => {
        commit("setNoteSubject", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addNoteSubject({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(hamyarUrl + "basic/hamyar/NoteSubject", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editNoteSubject({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(hamyarUrl + "basic/hamyar/NoteSubject/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteNoteSubject({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(hamyarUrl + "basic/hamyar/NoteSubject", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getNoteSubjectCode({ dispatch, commit }) {
    axios
      .get(hamyarUrl + "basic/hamyar/NoteSubject/MaxCode")
      .then((res) => {
        commit("setNoteSubjectCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // RequestType Actions ------------------------------------------------------------------
  getRequestTypes({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(hamyarUrl + "basic/hamyar/RequestType?" + data)
      .then((res) => {
        commit("setRequestTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getRequestType({ dispatch, commit }, data) {
    axios
      .get(hamyarUrl + "basic/hamyar/RequestType/" + data)
      .then((res) => {
        commit("setRequestType", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addRequestType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(hamyarUrl + "basic/hamyar/RequestType", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editRequestType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(hamyarUrl + "basic/hamyar/RequestType/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteRequestType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(hamyarUrl + "basic/hamyar/RequestType", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getRequestTypeCode({ dispatch, commit }) {
    axios
      .get(hamyarUrl + "basic/hamyar/RequestType/MaxCode")
      .then((res) => {
        commit("setRequestTypeCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // CallSubject Actions ------------------------------------------------------------------
  getCallSubjects({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(hamyarUrl + "basic/hamyar/CallSubject?" + data)
      .then((res) => {
        commit("setCallSubjects", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getCallSubject({ dispatch, commit }, data) {
    axios
      .get(hamyarUrl + "basic/hamyar/CallSubject/" + data)
      .then((res) => {
        commit("setCallSubject", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addCallSubject({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(hamyarUrl + "basic/hamyar/CallSubject", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editCallSubject({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(hamyarUrl + "basic/hamyar/CallSubject/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteCallSubject({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(hamyarUrl + "basic/hamyar/CallSubject", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getCallSubjectCode({ dispatch, commit }) {
    axios
      .get(hamyarUrl + "basic/hamyar/CallSubject/MaxCode")
      .then((res) => {
        commit("setCallSubjectCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // CallCategory Actions ------------------------------------------------------------------
  getCallCategories({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(hamyarUrl + "basic/hamyar/CallCategory?" + data)
      .then((res) => {
        commit("setCallCategories", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getCallCategory({ dispatch, commit }, data) {
    axios
      .get(hamyarUrl + "basic/hamyar/CallCategory/" + data)
      .then((res) => {
        commit("setCallCategory", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addCallCategory({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(hamyarUrl + "basic/hamyar/CallCategory", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editCallCategory({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(hamyarUrl + "basic/hamyar/CallCategory/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteCallCategory({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(hamyarUrl + "basic/hamyar/CallCategory", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getCallCategoryCode({ dispatch, commit }) {
    axios
      .get(hamyarUrl + "basic/hamyar/CallCategory/MaxCode")
      .then((res) => {
        commit("setCallCategoryCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // ServiceSupportSubject Actions ------------------------------------------------------------------
  getServiceSupportSubjects({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(hamyarUrl + "basic/service/ServiceSupportSubject?" + data)
      .then((res) => {
        commit("setServiceSupportSubjects", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getServiceSupportSubject({ dispatch, commit }, data) {
    axios
      .get(hamyarUrl + "basic/service/ServiceSupportSubject/" + data)
      .then((res) => {
        commit("setServiceSupportSubject", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addServiceSupportSubject({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(hamyarUrl + "basic/service/ServiceSupportSubject", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editServiceSupportSubject({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(
        hamyarUrl + "basic/service/ServiceSupportSubject/" + data.id,
        data.value,
      )
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteServiceSupportSubject({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(hamyarUrl + "basic/service/ServiceSupportSubject", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getServiceSupportSubjectCode({ dispatch, commit }) {
    axios
      .get(hamyarUrl + "basic/service/ServiceSupportSubject/MaxCode")
      .then((res) => {
        commit("setServiceSupportSubjectCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // Setting Actions ------------------------------------------------------------------
  getSetting({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(hamyarUrl + "basic/hamyar/Setting")
      .then((res) => {
        commit("setSetting", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  editSetting({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(hamyarUrl + "basic/hamyar/Setting/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Dashboard Actions ------------------------------------------------------------------
  getHamyarDashboard({ dispatch }) {
    return axios
      .get(hamyarUrl + "operation/hamyar/Dashboard")
      .then((res) => res.data.data || {})
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
        return null;
      });
  },

  // ServiceSupport Actions ------------------------------------------------------------------
  getServiceSupports({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(hamyarUrl + "operation/service/ServiceSupport?" + data)
      .then((res) => {
        commit("setServiceSupports", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getServiceSupport({ dispatch, commit }, data) {
    axios
      .get(hamyarUrl + "operation/service/ServiceSupport/" + data)
      .then((res) => {
        commit("setServiceSupport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addServiceSupport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(hamyarUrl + "operation/service/ServiceSupport", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          { server: res, message: alert.success.save, redirect: false },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editServiceSupport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(
        hamyarUrl + "operation/service/ServiceSupport/" + data.id,
        data.value,
      )
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          { server: res, message: alert.success.edit, redirect: false },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteServiceSupport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(hamyarUrl + "operation/service/ServiceSupport", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          { server: res, message: alert.success.delete, redirect: false },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getServiceSupportCode({ dispatch, commit }) {
    axios
      .get(hamyarUrl + "operation/service/ServiceSupport/MaxCode")
      .then((res) => {
        commit("setServiceSupportCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // Contract Actions ------------------------------------------------------------------
  getContracts({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(hamyarUrl + "operation/hamyar/Contract?" + data)
      .then((res) => {
        commit("setContracts", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getContract({ dispatch, commit }, data) {
    return axios
      .get(hamyarUrl + "operation/hamyar/Contract/" + data)
      .then((res) => {
        commit("setContract", res.data.data);
        return res.data.data;
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
        return null;
      });
  },

  addContract({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(hamyarUrl + "operation/hamyar/Contract", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          { server: res, message: alert.success.save, redirect: false },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editContract({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(hamyarUrl + "operation/hamyar/Contract/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          { server: res, message: alert.success.edit, redirect: false },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteContract({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(hamyarUrl + "operation/hamyar/Contract", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          { server: res, message: alert.success.delete, redirect: false },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getContractCode({ dispatch, commit }) {
    axios
      .get(hamyarUrl + "operation/hamyar/Contract/MaxCode")
      .then((res) => {
        commit("setContractCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // Task Actions ------------------------------------------------------------------
  getTasks({ dispatch, commit }, data) {
    axios
      .get(hamyarUrl + "operation/hamyar/Task?" + data)
      .then((res) => {
        commit("setTasks", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getTask({ dispatch, commit }, data) {
    axios
      .get(hamyarUrl + "operation/hamyar/Task/" + data)
      .then((res) => {
        commit("setTask", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // رکورد کامل وظیفه برای پنل جزئیات؛ چیزی در store ذخیره نمی‌شود
  // تا فرم مودال ویرایش با آن بازنویسی نشود
  getTaskRecord({ dispatch }, data) {
    const get = (path) =>
      axios.get(hamyarUrl + path).then((res) => res.data.data);
    return Promise.all([
      get("operation/hamyar/Task/" + data),
      get(
        "operation/hamyar/TaskTeam?TaskId=" +
          encodeURIComponent(data) +
          "&PageNumber=1&PageSize=1000",
      ).catch(() => null),
    ])
      .then(([task, teams]) => {
        const rows = Array.isArray(teams)
          ? teams
          : teams && Array.isArray(teams.data)
          ? teams.data
          : [];
        return rows.length ? { ...task, taskTeams: rows } : task;
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
        return null;
      });
  },

  addTask({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    const { body, wanted } = splitCheckDone(data);
    axios
      .post(hamyarUrl + "operation/hamyar/Task", body)
      .then((res) =>
        restoreCheckDone("operation/hamyar/Task/", res.data.data, wanted).then(
          () => res,
        ),
      )
      .then((res) => {
        commit("setTaskId", res.data.data);
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editTask({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    const { body, wanted } = splitCheckDone(data.value);
    axios
      .put(hamyarUrl + "operation/hamyar/Task/" + data.id, body)
      .then((res) =>
        restoreCheckDone("operation/hamyar/Task/", data.id, wanted).then(
          () => res,
        ),
      )
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteTask({ dispatch, commit }, data) {
    const ids = Array.isArray(data) ? data : data.ids;
    const scopeId = Array.isArray(data) ? null : data.scopeId;
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(
        hamyarUrl +
          "operation/hamyar/Task" +
          (scopeId ? "?scopeId=" + scopeId : ""),
        { data: ids },
      )
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getTaskCode({ dispatch, commit }) {
    axios
      .get(hamyarUrl + "operation/hamyar/Task/MaxCode")
      .then((res) => {
        commit("setTaskCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // پیمایش رکوردها در فرم وظیفه: navigation=1..4 یا جستجو با code
  getTaskNavigation({ dispatch, commit }, data) {
    axios
      .get(hamyarUrl + "operation/hamyar/Task/Navigation?" + data)
      .then((res) => {
        commit("setTaskNavigation", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  changeStatusTask({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(
        hamyarUrl + "operation/hamyar/Task/ChangeStatus/" + data.id,
        data.value,
      )
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  referTask({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    return axios
      .put(hamyarUrl + "operation/hamyar/Task/Refer/" + data.id, data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
        return true;
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return false;
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getTaskTimer({ dispatch }, id) {
    return axios
      .get(hamyarUrl + "operation/hamyar/Task/Timer/" + id)
      .then((res) => res.data.data)
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
        return null;
      });
  },

  stopTaskTimer({ dispatch }, data) {
    return axios
      .put(hamyarUrl + "operation/hamyar/Task/StopTimer/" + data.id, data)
      .then(() => true)
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return false;
      });
  },

  // شروع/توقف زمان‌سنج یک وظیفه؛ وضعیت نامعلوم اول از سرور گرفته می‌شود
  toggleTaskTimer({ state, commit, dispatch }, task) {
    const id = task.id;
    const known = state.taskTimers[id];
    const title = task.title || known?.title;
    return Promise.resolve(known || dispatch("getTaskTimer", id))
      .then((timer) => {
        if (!timer) return null;
        if (!timer.isRunning) return dispatch("startTaskTimer", id);
        // StopTimer فقط موفق/ناموفق برمی‌گرداند
        return dispatch("stopTaskTimer", { id }).then((ok) =>
          ok ? { ...timer, isRunning: false } : null,
        );
      })
      .then((result) => {
        if (result) {
          commit("setTaskTimer", { id, timer: timerRecord(result, id, title) });
          saveRunningTimers(state.taskTimers);
        }
        return result;
      });
  },

  // بعد از ارجاع (که زمان‌سنج را متوقف می‌کند) وضعیت دوباره از سرور گرفته شود
  forgetTaskTimer({ state, commit }, id) {
    commit("removeTaskTimer", id);
    saveRunningTimers(state.taskTimers);
  },

  // بازگرداندن زمان‌سنج‌های روشن بعد از رفرش؛ بی‌صدا، چون وظیفه شاید حذف شده باشد
  restoreTaskTimers({ state, commit }) {
    const saved = readRunningTimers();
    return Promise.all(
      saved.map((item) =>
        axios
          .get(hamyarUrl + "operation/hamyar/Task/Timer/" + item.id)
          .then((res) => {
            const timer = res.data.data;
            if (timer && timer.isRunning) {
              commit("setTaskTimer", {
                id: item.id,
                timer: timerRecord(timer, item.id, item.title),
              });
            }
          })
          .catch(() => null),
      ),
    ).then(() => saveRunningTimers(state.taskTimers));
  },

  // شروع زمان‌سنج وظیفه؛ TaskTimerResult را برمی‌گرداند (در خطا null)
  startTaskTimer({ dispatch }, id) {
    return axios
      .post(hamyarUrl + "operation/hamyar/Task/StartTimer/" + id)
      .then((res) => res.data.data)
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return null;
      });
  },

  setCheckListDone({ dispatch }, data) {
    return axios
      .put(hamyarUrl + "operation/hamyar/CheckList/SetDone", data)
      .then(() => true)
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return false;
      });
  },

  // TaskTeam Actions ------------------------------------------------------------------
  getTaskTeams({ dispatch, commit }, data) {
    axios
      .get(hamyarUrl + "operation/hamyar/TaskTeam?" + data)
      .then((res) => {
        commit("setTaskTeams", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getTaskTeam({ dispatch, commit }, data) {
    axios
      .get(hamyarUrl + "operation/hamyar/TaskTeam/" + data)
      .then((res) => {
        commit("setTaskTeam", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addTaskTeam({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(hamyarUrl + "operation/hamyar/TaskTeam", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editTaskTeam({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(hamyarUrl + "operation/hamyar/TaskTeam/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteTaskTeam({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(hamyarUrl + "operation/hamyar/TaskTeam", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Message Actions ------------------------------------------------------------------
  getMessages({ dispatch, commit }, data) {
    axios
      .get(hamyarUrl + "operation/hamyar/Message?" + data)
      .then((res) => {
        commit("setMessages", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getMessage({ dispatch, commit }, data) {
    axios
      .get(hamyarUrl + "operation/hamyar/Message/" + data)
      .then((res) => {
        commit("setMessage", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addMessage({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    const { body, wanted } = splitCheckDone(data);
    axios
      .post(hamyarUrl + "operation/hamyar/Message", body)
      .then((res) =>
        restoreCheckDone("operation/hamyar/Message/", res.data.data, wanted).then(
          () => res,
        ),
      )
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editMessage({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    const { body, wanted } = splitCheckDone(data.value);
    axios
      .put(hamyarUrl + "operation/hamyar/Message/" + data.id, body)
      .then((res) =>
        restoreCheckDone("operation/hamyar/Message/", data.id, wanted).then(
          () => res,
        ),
      )
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteMessage({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(hamyarUrl + "operation/hamyar/Message", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getMessageCode({ dispatch, commit }) {
    axios
      .get(hamyarUrl + "operation/hamyar/Message/MaxCode")
      .then((res) => {
        commit("setMessageCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // Call Actions ------------------------------------------------------------------
  getCalls({ dispatch, commit }, data) {
    axios
      .get(hamyarUrl + "operation/hamyar/Call?" + data)
      .then((res) => {
        commit("setCalls", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getCall({ dispatch, commit }, data) {
    axios
      .get(hamyarUrl + "operation/hamyar/Call/" + data)
      .then((res) => {
        commit("setCall", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addCall({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    const { body, wanted } = splitCheckDone(data);
    axios
      .post(hamyarUrl + "operation/hamyar/Call", body)
      .then((res) =>
        restoreCheckDone("operation/hamyar/Call/", res.data.data, wanted).then(
          () => res,
        ),
      )
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editCall({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    const { body, wanted } = splitCheckDone(data.value);
    axios
      .put(hamyarUrl + "operation/hamyar/Call/" + data.id, body)
      .then((res) =>
        restoreCheckDone("operation/hamyar/Call/", data.id, wanted).then(
          () => res,
        ),
      )
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteCall({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(hamyarUrl + "operation/hamyar/Call", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  changeStatusCall({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(
        hamyarUrl + "operation/hamyar/Call/ChangeStatus/" + data.id,
        data.value,
      )
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getCallCode({ dispatch, commit }) {
    axios
      .get(hamyarUrl + "operation/hamyar/Call/MaxCode")
      .then((res) => {
        commit("setCallCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // Request Actions ------------------------------------------------------------------
  getRequests({ dispatch, commit }, data) {
    axios
      .get(hamyarUrl + "operation/hamyar/Request?" + data)
      .then((res) => {
        commit("setRequests", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getRequest({ dispatch, commit }, data) {
    axios
      .get(hamyarUrl + "operation/hamyar/Request/" + data)
      .then((res) => {
        commit("setRequest", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addRequest({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(hamyarUrl + "operation/hamyar/Request", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editRequest({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(hamyarUrl + "operation/hamyar/Request/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteRequest({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(hamyarUrl + "operation/hamyar/Request", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getRequestCode({ dispatch, commit }) {
    axios
      .get(hamyarUrl + "operation/hamyar/Request/MaxCode")
      .then((res) => {
        commit("setRequestCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // Note Actions ------------------------------------------------------------------
  getNotes({ dispatch, commit }, data) {
    axios
      .get(hamyarUrl + "operation/hamyar/Note?" + data)
      .then((res) => {
        commit("setNotes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getNote({ dispatch, commit }, data) {
    axios
      .get(hamyarUrl + "operation/hamyar/Note/" + data)
      .then((res) => {
        commit("setNote", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addNote({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    const { body, wanted } = splitCheckDone(data);
    axios
      .post(hamyarUrl + "operation/hamyar/Note", body)
      .then((res) =>
        restoreCheckDone("operation/hamyar/Note/", res.data.data, wanted).then(
          () => res,
        ),
      )
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editNote({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    const { body, wanted } = splitCheckDone(data.value);
    axios
      .put(hamyarUrl + "operation/hamyar/Note/" + data.id, body)
      .then((res) =>
        restoreCheckDone("operation/hamyar/Note/", data.id, wanted).then(
          () => res,
        ),
      )
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteNote({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(hamyarUrl + "operation/hamyar/Note", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getNoteCode({ dispatch, commit }) {
    axios
      .get(hamyarUrl + "operation/hamyar/Note/MaxCode")
      .then((res) => {
        commit("setNoteCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // Meeting Actions ------------------------------------------------------------------
  getMeetings({ dispatch, commit }, data) {
    axios
      .get(hamyarUrl + "operation/hamyar/Meeting?" + data)
      .then((res) => {
        commit("setMeetings", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getMeeting({ dispatch, commit }, data) {
    axios
      .get(hamyarUrl + "operation/hamyar/Meeting/" + data)
      .then((res) => {
        commit("setMeeting", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addMeeting({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    const { body, wanted } = splitCheckDone(data);
    axios
      .post(hamyarUrl + "operation/hamyar/Meeting", body)
      .then((res) =>
        restoreCheckDone("operation/hamyar/Meeting/", res.data.data, wanted).then(
          () => res,
        ),
      )
      .then((res) => {
        commit("setMeetingId", res.data.data);
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editMeeting({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    const { body, wanted } = splitCheckDone(data.value);
    axios
      .put(hamyarUrl + "operation/hamyar/Meeting/" + data.id, body)
      .then((res) =>
        restoreCheckDone("operation/hamyar/Meeting/", data.id, wanted).then(
          () => res,
        ),
      )
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteMeeting({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(hamyarUrl + "operation/hamyar/Meeting", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getMeetingCode({ dispatch, commit }) {
    axios
      .get(hamyarUrl + "operation/hamyar/Meeting/MaxCode")
      .then((res) => {
        commit("setMeetingCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  // Project Actions ------------------------------------------------------------------
  getProjects({ dispatch, commit }, data) {
    axios
      .get(hamyarUrl + "operation/hamsaz/HamyarProject?" + data)
      .then((res) => {
        commit("setProjects", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getProject({ dispatch, commit }, data) {
    axios
      .get(hamyarUrl + "operation/hamsaz/HamyarProject/" + data)
      .then((res) => {
        commit("setProject", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // رکورد کامل پروژه برای پنل جزئیات؛ چیزی در store ذخیره نمی‌شود
  // تا فرم مودال ویرایش و جابه‌جایی کانبان با آن تداخل نداشته باشد
  getProjectRecord({ dispatch }, data) {
    return axios
      .get(hamyarUrl + "operation/hamsaz/HamyarProject/" + data)
      .then((res) => res.data.data)
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
        return null;
      });
  },

  addProject({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(hamyarUrl + "operation/hamsaz/HamyarProject", data)
      .then((res) => {
        commit("setProjectId", res.data.data);
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editProject({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(hamyarUrl + "operation/hamsaz/HamyarProject/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteProject({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(hamyarUrl + "operation/hamsaz/HamyarProject", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getProjectCode({ dispatch, commit }) {
    axios
      .get(hamyarUrl + "operation/hamsaz/HamyarProject/MaxCode")
      .then((res) => {
        commit("setProjectCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // ProjectTeam Actions ------------------------------------------------------------------
  getProjectTeams({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(hamyarUrl + "operation/hamsaz/HamyarProjectTeam?" + data)
      .then((res) => {
        commit("setProjectTeams", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addProjectTeam({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(hamyarUrl + "operation/hamsaz/HamyarProjectTeam", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editProjectTeam({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(
        hamyarUrl + "operation/hamsaz/HamyarProjectTeam/" + data.id,
        data.value,
      )
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteProjectTeam({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(hamyarUrl + "operation/hamsaz/HamyarProjectTeam", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Reminder Actions ------------------------------------------------------------------
  getReminders({ dispatch, commit }, data) {
    axios
      .get(hamyarUrl + "operation/hamyar/Reminder?" + data)
      .then((res) => {
        commit("setReminders", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
};
